module.exports = __webpack_public_path__ + "img/0e8d6b2.png";